"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectFolder_1 = require("./selectFolder");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var owa_mail_favorites_store_2 = require("owa-mail-favorites-store");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var owa_mail_folder_store_1 = require("owa-mail-folder-store");
var deleteFolder_1 = require("owa-mail-folder-store/lib/actions/deleteFolder");
var owa_mail_move_mru_1 = require("owa-mail-move-mru");
var Store_1 = require("owa-mail-store/lib/store/Store");
var isFolderUnderDeletedFolder_1 = require("owa-mail-store/lib/utils/isFolderUnderDeletedFolder");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Called on folders deleted
 * @param folderIds the folder ids that have been deleted
 * @param state the state which contains the favorite ids
 */
exports.default = legacy_1.action('deleteFolderInFolderForest')(legacy_1.select({
    favoritesFolderNodes: function () { return owa_mail_favorites_store_2.favoritesStore.favoritesFolderNodes; },
    folders: function () { return Store_1.default.folders; },
})(function deleteFolderInFolderForest(folderId, actionSource, state) {
    var _this = this;
    var favoritesFolderNodes = state.favoritesFolderNodes, folders = state.folders;
    var folderIdsToDelete = owa_mail_folder_store_1.getAllSubFolderIds(folderId);
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    // TODO: VSO 8717: Show a different dialog when deleting a folder when folder with the same name exists under deleted items folder
    // TODO: VSO 11474: Fix delete scenario for public folder and archive delted items folder
    // If the item is in the deleted items folder or in PublicFolder or in archived deleted items folder, perform a softdelete.
    var isFolderUnderDeletedItemFolder = isFolderUnderDeletedFolder_1.default(folderToDelete);
    var confirmationSubText = isFolderUnderDeletedItemFolder
        ? owa_mail_strings_1.default.confirmPermanentDeleteFolderSubText
        : owa_mail_strings_1.default.confirmDeleteFolderSubText;
    // Popout the confirmation dialog
    owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.confirmDeleteFolderText, owa_strings_1.format(confirmationSubText, folderToDelete.DisplayName)).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                folderIdsToDelete.forEach(function (id) {
                    // Try remove the folder id from the favorites if it's in favorites
                    tryRemoveFromFavorites(id, favoritesFolderNodes, actionSource);
                    // Reset selection to inbox if we are deleting selected folder or if it is a part of subtree being deleted
                    if (id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
                        selectFolder_1.default(folderNameToId_1.default('inbox'), 'primaryFolderTree' /* treeType */);
                    }
                });
                // Remove the folder from the folder store and sends out deleteFolder service request
                return [2 /*return*/, deleteFolder_1.default(folders, folderId, isFolderUnderDeletedItemFolder /* softDelete */)];
            }
            return [2 /*return*/];
        });
    }); });
    // Update move to folder mru list
    owa_mail_move_mru_1.lazyRemoveFolderIdFromMoveToMruList.importAndExecute(folderId);
}));
/**
 * Try remove the id from favorite folder ids if it's in the list
 * @param folderIds the folder ids that have been deleted
 * @param favoritesFolderNodes the favorite nodes
 */
function tryRemoveFromFavorites(idToRemove, favoritesFolderNodes, actionSource) {
    if (favoritesFolderNodes.has(idToRemove)) {
        owa_mail_favorites_store_1.lazyRemoveFavoriteFolder.importAndExecute(idToRemove, actionSource);
    }
}
//# sourceMappingURL=deleteFolderInFolderForest.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-folder-forest-actions/lib/actions/deleteFolderInFolderForest.js
// module id = 4730
// module chunks = 23